// extracted by mini-css-extract-plugin
module.exports = {"singleCta":"SingleCtaOutlet_singleCta__appv_","active":"SingleCtaOutlet_active__tLx3T"};